/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Admin_OnlyInputs */

const cs_gdpr_admin_only = /** @type {(inputs: Gdpr_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen pro administrátory kanceláře.`)
};

const en_gdpr_admin_only = /** @type {(inputs: Gdpr_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office admins only.`)
};

/**
* | output |
* | --- |
* | "Office admins only." |
*
* @param {Gdpr_Admin_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_admin_only = /** @type {((inputs?: Gdpr_Admin_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Admin_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_admin_only(inputs)
	return cs_gdpr_admin_only(inputs)
});